/*
 * valea-en.js — layer di traduzione EN per valeaitalia.com
 *
 * Il tema e i prodotti di questo store sono tradotti alla sorgente. Restano
 * fuori portata solo i contenuti che vivono nell'admin Shopify e per cui il
 * token dello store non ha scope: le voci di menu (Navigazione) e le etichette
 * dei filtri di collezione (app Search & Discovery).
 *
 * Sostituisce SOLO a stringa intera, mai sottostringhe. Non tocca <script>,
 * <style>, <input>: lo snippet del checkout Krown legge i valori delle option
 * e va lasciato intatto.
 *
 * Sostituisce il vecchio valea-i18n.js, che traduceva il sito in SPAGNOLO.
 */
(function () {
  'use strict';

  var EXACT = {
    /* voci di menu (admin -> Navigazione) */
    'Cerca': 'Search',
    'Chi siamo': 'About us',
    'Spedizioni e resi': 'Shipping and returns',
    'Contatti': 'Contact',

    /* etichette dei filtri di collezione (admin -> Search & Discovery) */
    'Disponibilità': 'Availability',
    'Prezzo': 'Price',
    'Esaurito': 'Out of stock',
    'Disponibile': 'In stock',

    /* etichette di ordinamento generate da Shopify */
    'Prezzo crescente': 'Price, low to high',
    'Prezzo decrescente': 'Price, high to low',
    'In evidenza': 'Featured',
    'Più venduti': 'Best selling',
    'Rilevanza': 'Relevance',
    'Pertinenza': 'Relevance',

    /* nome del blog (admin) e paginazione */
    'Notizie': 'News',
    'Precedente': 'Previous',
    'Successiva': 'Next'
  };

  var RULES = [
    [/^Disponibilità\s*\((\d+)\s*selected\)$/i, 'Availability ($1 selected)'],
    [/^Prezzo\s*\((\d+)\s*selected\)$/i, 'Price ($1 selected)']
  ];

  function convert(s) {
    var k = s.trim();
    if (!k) return null;
    if (Object.prototype.hasOwnProperty.call(EXACT, k)) return s.replace(k, EXACT[k]);
    for (var i = 0; i < RULES.length; i++) {
      if (RULES[i][0].test(k)) return s.replace(k, k.replace(RULES[i][0], RULES[i][1]));
    }
    return null;
  }

  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1 };

  function walk(root) {
    if (!root || !root.querySelectorAll) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SKIP[p.nodeName]) return NodeFilter.FILTER_REJECT;
        return n.nodeValue && n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var n, batch = [];
    while ((n = w.nextNode())) batch.push(n);
    for (var i = 0; i < batch.length; i++) {
      var o = convert(batch[i].nodeValue);
      if (o !== null) batch[i].nodeValue = o;
    }
    var els = root.querySelectorAll('[alt],[title],[aria-label],[placeholder]');
    for (var j = 0; j < els.length; j++) {
      ['alt', 'title', 'aria-label', 'placeholder'].forEach(function (a) {
        var v = els[j].getAttribute(a);
        if (!v) return;
        var o = convert(v);
        if (o !== null) els[j].setAttribute(a, o);
      });
    }
  }

  function fixTitle() {
    // Il <title> e' composto: "<pagina>\n &ndash; Valea". Va normalizzato e
    // spezzato, altrimenti "Notizie – Valea" non aggancia nessuna chiave.
    var raw = document.title.replace(/\s+/g, ' ').trim();
    var m = raw.match(/^(.*?)\s+[–—-]\s+(.*)$/);
    if (m) {
      var left = convert(m[1]);
      raw = (left !== null ? left.trim() : m[1]) + ' – ' + m[2];
    } else {
      var whole = convert(raw);
      if (whole !== null) raw = whole.trim();
    }
    if (raw !== document.title) document.title = raw;
  }

  function run() {
    walk(document.body);
    fixTitle();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // I filtri di collezione e il carrello a scomparsa si ridisegnano via AJAX.
  var pending = false;
  var obs = new MutationObserver(function (muts) {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1) walk(n);
          else if (n.nodeType === 3) {
            var o = convert(n.nodeValue);
            if (o !== null) n.nodeValue = o;
          }
        }
      }
    });
  });
  function observe() {
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) observe();
  else document.addEventListener('DOMContentLoaded', observe);
})();
